import apiServiceConfig from '@/core/config/apiService'
import { get , post } from '@/core/models/axios'

export default class homePage {
    /**
     * 字典
     * @param dictType 字典类型
     * @returns {Promise<*>}
     */
    static async getHomePageData() {
      return get(apiServiceConfig.getHomePageData)
    }


    static async getPageByMenuId(id) {
      return get(apiServiceConfig.getPageByMenuId+'/'+id)
    }
    
    static async getArticleList(data) {
      return get(apiServiceConfig.getArticleList,data)
    }
    static async getChildrenMenu(id) {
      return get(apiServiceConfig.getChildrenMenu + "/" + id);
    }
    static async getArticleById(id) {
      return get(apiServiceConfig.getArticleById+'/'+id)
    }
    
    static async getPartyBuildData() {
      return get(apiServiceConfig.getPartyBuildData)
    }
    
    static async getWaterCultureData() {
      return get(apiServiceConfig.getWaterCultureData)
    }
    static async submitFeedback({ name, mobile, email, title, content }) {
      return post(apiServiceConfig.submitFeedback, {
        name,
        mobile,
        email,
        title,
        content,
      });
    }
    static async submitCustomerDemand(data) {
      return post(apiServiceConfig.submitCustomerDemand,data)
    }
    
}
